import { useEffect, useState } from 'react'

/** O valor depois de `delay` ms sem mudar: a busca não dispara a cada tecla. */
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])
  return debounced
}
